<img class="img-fluid" [src]="src" [alt]="alt">